import { render, staticRenderFns } from "./edit_document.vue?vue&type=template&id=351a8ae3"
import script from "./edit_document.vue?vue&type=script&lang=js"
export * from "./edit_document.vue?vue&type=script&lang=js"
import style0 from "./edit_document.vue?vue&type=style&index=0&id=351a8ae3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports